(function () {
  var STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-addons';
  var PICKED_CLASS = 'ciw-la-lens-card--picked';
  var BODY_ACTIVE_CLASS = 'ciw-la-addons-continue-active';
  var pendingWrapper = null;
  var confirming = false;
  var boundScope = null;
  /* Mobile sunglasses package advances on pointerdown. The leftover click/touch
     lands on whichever upgrade card appears under the finger (often Super
     Hydrophobic) and looks like an auto-selection. Ignore picks briefly —
     only when arriving from package, not when returning via Back. */
  var MQ_MOBILE = window.matchMedia('(max-width: 749px)');
  var ghostClickIgnoreUntil = 0;
  var ghostClickClearTimer = null;
  var armGhostGuardOnActivate = false;

  function armGhostClickGuard(ms) {
    if (!MQ_MOBILE.matches) return;
    ghostClickIgnoreUntil = Date.now() + (ms || 500);
    if (ghostClickClearTimer) window.clearTimeout(ghostClickClearTimer);
    ghostClickClearTimer = window.setTimeout(function () {
      ghostClickClearTimer = null;
      if (!document.body.classList.contains(BODY_ACTIVE_CLASS)) return;
      var scope = getScope();
      if (!scope) return;
      clearCheckedInputs(scope, true);
      if (pendingWrapper) setPicked(null);
    }, (ms || 500) + 20);
  }

  function isGhostClickWindow() {
    return MQ_MOBILE.matches && Date.now() < ghostClickIgnoreUntil;
  }

  document.addEventListener('ciw-la-addons:arm-ghost-guard', function () {
    armGhostGuardOnActivate = true;
  });

  function getScope() {
    return document.querySelector(STEP_SELECTOR);
  }

  function isActive() {
    return !!(window.ciwLaHostApi && window.ciwLaHostApi.isEyeglass()) && !!getScope();
  }

  function getWrappers(scope) {
    scope = scope || getScope();
    if (!scope) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('.la-label-btn-wrapper'));
  }

  function getCardBtn(wrapper) {
    return wrapper ? wrapper.querySelector('.la-label-btn') : null;
  }

  function getInput(wrapper) {
    if (!wrapper) return null;
    return (
      wrapper.querySelector('input[type="checkbox"]') ||
      wrapper.querySelector('input[type="radio"]')
    );
  }

  function canSkip(scope) {
    scope = scope || getScope();
    if (!scope) return false;
    return !!scope.querySelector('.la-skip-add-on-wrapper, .la-skip-add-on');
  }

  function isDeclineWrapper(wrapper) {
    if (!wrapper) return false;
    var btn = getCardBtn(wrapper);
    if (btn && btn.classList.contains('ciw-la-lens-card--decline')) return true;
    var titleNode = wrapper.querySelector('.la-label-title');
    var title = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
    if (/no thanks,\s*basic anti-glare is fine/i.test(title)) return true;
    /* la-translate may not have filled .la-label-title yet — fall back to wrapper text */
    return /no thanks,\s*basic anti-glare is fine/i.test(
      wrapper.textContent.replace(/\s+/g, ' ').trim()
    );
  }

  function isReviewStepVisible() {
    var review = document.querySelector('.la-choose-prescription-wrapper.la-render-review');
    if (!review || review.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(review);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return review.getClientRects().length > 0;
  }

  function clearCheckedInputs(scope, silent) {
    getWrappers(scope).forEach(function (wrapper) {
      var input = getInput(wrapper);
      if (!input || !input.checked) return;
      input.checked = false;
      if (!silent) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function setPicked(wrapper) {
    var scope = getScope();
    if (!scope) return;

    getWrappers(scope).forEach(function (item) {
      var btn = getCardBtn(item);
      if (!btn) return;
      btn.classList.toggle(PICKED_CLASS, item === wrapper);
    });

    pendingWrapper = wrapper || null;
    document.dispatchEvent(new CustomEvent('ciw-la-addons:selection-changed'));
  }

  function getCheckedWrapper(scope) {
    scope = scope || getScope();
    if (!scope) return null;
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      var input = getInput(wrappers[i]);
      if (input && input.checked) return wrappers[i];
    }
    return null;
  }

  /* True if the customer picked an add-on via our intercept (pendingWrapper) OR a
     native checkbox/radio slipped through and is checked. The native fallback matters
     on desktop: if a click lands during one of LensAdvizor's re-renders (before our
     capture listener is re-bound), the input toggles natively and pendingWrapper stays
     null — which used to leave the "Save and Continue" button hidden. */
  function hasSelection() {
    if (pendingWrapper) return true;
    return !!getCheckedWrapper();
  }

  function isInteractiveTarget(target) {
    return !!(
      target &&
      target.closest &&
      target.closest('[data-la-tooltip], .tooltip-span, .la-tooltip, .la-help-icon')
    );
  }

  function getWrapperFromEventTarget(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('.la-label-btn');
    if (!btn) return null;
    return btn.closest('.la-label-btn-wrapper');
  }

  function togglePicked(wrapper) {
    if (pendingWrapper === wrapper) {
      setPicked(null);
      return;
    }
    setPicked(wrapper);
  }

  function onStepClickCapture(event) {
    if (!isActive() || confirming) return;

    if (isGhostClickWindow()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      clearCheckedInputs(getScope(), true);
      if (pendingWrapper) setPicked(null);
      return;
    }

    var scope = getScope();
    var wrapper = getWrapperFromEventTarget(event.target);

    if (wrapper && scope && scope.contains(wrapper) && isDeclineWrapper(wrapper)) {
      if (!isActive() || confirming) return;
      var declineScope = getScope();
      if (!declineScope) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      confirming = true;
      clearCheckedInputs(declineScope, true);
      deactivateStep();

      try {
        if (typeof declineScope.requestSubmit === 'function') {
          declineScope.requestSubmit();
        } else {
          declineScope.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      } finally {
        confirming = false;
        pendingWrapper = null;
      }
      return;
    }

    var input =
      event.target.closest &&
      event.target.closest('.la-label-btn input[type="checkbox"], .la-label-btn input[type="radio"]');
    if (input && scope && scope.contains(input)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      togglePicked(input.closest('.la-label-btn-wrapper'));
      return;
    }

    if (isInteractiveTarget(event.target)) return;

    if (!wrapper || !scope.contains(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    togglePicked(wrapper);
  }

  function isBridgedSunglassesUpgrades() {
    return document.body.classList.contains('ciw-la-sunglasses-bridged-upgrades');
  }

  function isAddonsStepStillShowing() {
    var scope = getScope();
    return !!(scope && isScopeVisible(scope) && !isReviewStepVisible());
  }

  /* Bridged Solid-tint upgrades: LA's skip button + form submit do not advance
     (submit can even jump to Lens type). renderReview() is the reliable path. */
  function advanceToReview() {
    var la = window.LensAdvizor;
    if (!la || typeof la.renderReview !== 'function') return false;
    try {
      la.renderReview();
      return true;
    } catch (e) {
      return false;
    }
  }

  function clearLaAddonSelections() {
    var la = window.LensAdvizor;
    if (!la || !la.response) return;
    la.response.addOns = {};
  }

  function skipAddons(fromDecline) {
    if (!isActive() || confirming) return false;

    var scope = getScope();
    if (!scope) return false;
    if (!fromDecline && !canSkip(scope)) return false;

    confirming = true;
    clearCheckedInputs(scope, true);
    clearLaAddonSelections();

    var skip =
      scope.querySelector('.la-skip-add-on-wrapper .la-skip-add-on, .la-skip-add-on') ||
      scope.querySelector('.la-skip-add-on-wrapper, .la-skip-add-on');

    try {
      if (isBridgedSunglassesUpgrades()) {
        deactivateStep();
        advanceToReview();
        return true;
      }

      if (canSkip(scope) && skip) {
        skip.click();
      } else if (typeof scope.requestSubmit === 'function') {
        scope.requestSubmit();
      } else {
        scope.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }

      deactivateStep();

      /* Native skip can also no-op after sunglasses package — don't leave Continue gone. */
      if (isAddonsStepStillShowing()) {
        advanceToReview();
      }
      return true;
    } finally {
      confirming = false;
      pendingWrapper = null;
    }
  }

  function confirmSelection() {
    if (!isActive() || confirming) return;

    var scope = getScope();
    if (!scope) return;

    var chosen = pendingWrapper || getCheckedWrapper(scope);
    if (!chosen) {
      if (canSkip(scope)) skipAddons();
      return;
    }

    confirming = true;

    getWrappers(scope).forEach(function (wrapper) {
      var input = getInput(wrapper);
      if (!input) return;
      var shouldCheck = wrapper === chosen;
      if (input.checked !== shouldCheck) {
        input.checked = shouldCheck;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    try {
      if (isBridgedSunglassesUpgrades()) {
        deactivateStep();
        advanceToReview();
        return;
      }

      deactivateStep();

      if (typeof scope.requestSubmit === 'function') {
        scope.requestSubmit();
      } else {
        scope.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }

      if (isAddonsStepStillShowing()) {
        advanceToReview();
      }
    } finally {
      confirming = false;
      pendingWrapper = null;
    }
  }

  function onContinueClick(event) {
    if (!isActive()) return;
    var btn = event.target.closest('.la-prescription-form-btn');
    if (!btn) return;
    if (
      !btn.closest('.la-prescription-modal-footer') &&
      !btn.closest('.la-prescription-modal-content-body') &&
      !btn.closest('.ciw-la-review-card__inner')
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!hasSelection() && canSkip(getScope())) {
      skipAddons();
      return;
    }

    confirmSelection();
  }

  /* Safety net: if a native checkbox/radio toggle slips past our capture click
     handler (e.g. the click lands mid re-render before we re-bind), sync our picked
     state + notify the footer so the action button still appears/updates. */
  function onStepChange(event) {
    if (confirming) return;
    var scope = getScope();
    if (!scope) return;
    var input = event.target;
    if (!input || !input.matches || !input.matches('input[type="checkbox"], input[type="radio"]')) return;
    if (!scope.contains(input)) return;

    if (isGhostClickWindow()) {
      if (input.checked) input.checked = false;
      clearCheckedInputs(scope, true);
      if (pendingWrapper) setPicked(null);
      return;
    }

    var wrapper = input.closest('.la-label-btn-wrapper');
    if (!wrapper) return;

    if (input.checked) {
      setPicked(wrapper);
    } else if (pendingWrapper === wrapper) {
      setPicked(null);
    } else {
      document.dispatchEvent(new CustomEvent('ciw-la-addons:selection-changed'));
    }
  }

  function bindScope(scope) {
    if (!scope || boundScope === scope) return;
    unbindScope();
    boundScope = scope;
    scope.addEventListener('click', onStepClickCapture, true);
    scope.addEventListener('change', onStepChange, true);
  }

  function unbindScope() {
    if (!boundScope) return;
    boundScope.removeEventListener('click', onStepClickCapture, true);
    boundScope.removeEventListener('change', onStepChange, true);
    boundScope = null;
  }

  function activateStep(scope) {
    scope = scope || getScope();
    if (!scope) return;

    if (window.ciwLaTransitionsDrawer && typeof window.ciwLaTransitionsDrawer.hideStaleTransitionSteps === 'function') {
      window.ciwLaTransitionsDrawer.hideStaleTransitionSteps(null);
    }

    var wasActive = document.body.classList.contains(BODY_ACTIVE_CLASS);
    document.body.classList.add(BODY_ACTIVE_CLASS);
    bindScope(scope);
    clearCheckedInputs(scope, true);

    /* Only arm when package→upgrades just fired the arm event — not on Back. */
    if (!wasActive && armGhostGuardOnActivate) {
      armGhostGuardOnActivate = false;
      armGhostClickGuard(500);
    }

    if (!wasActive || !pendingWrapper || !scope.contains(pendingWrapper)) {
      getWrappers(scope).forEach(function (wrapper) {
        var btn = getCardBtn(wrapper);
        if (btn) btn.classList.remove(PICKED_CLASS);
      });
      pendingWrapper = null;
    } else {
      setPicked(pendingWrapper);
    }

    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-addons:selection-changed'));
    }, 0);
  }

  function deactivateStep() {
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    var cleanupScope = boundScope;
    unbindScope();
    if (!cleanupScope) {
      pendingWrapper = null;
      return;
    }

    getWrappers(cleanupScope).forEach(function (wrapper) {
      var btn = getCardBtn(wrapper);
      if (btn) btn.classList.remove(PICKED_CLASS);
    });
    pendingWrapper = null;
  }

  function scan() {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isEyeglass()) {
      deactivateStep();
      return;
    }

    if (isReviewStepVisible()) {
      deactivateStep();
      return;
    }

    var scope = getScope();
    if (!scope) {
      deactivateStep();
      return;
    }

    if (!isScopeVisible(scope)) {
      deactivateStep();
      return;
    }

    activateStep(scope);
  }

  function isScopeVisible(scope) {
    if (!scope || scope.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(scope);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return scope.getClientRects().length > 0;
  }

  function scheduleScan() {
    scan();
    window.setTimeout(scan, 0);
    window.setTimeout(scan, 150);
    window.setTimeout(scan, 400);
    window.setTimeout(scan, 850);
    window.setTimeout(scan, 1600);
  }

  window.ciwLaAddonsContinue = {
    isActive: function () {
      return document.body.classList.contains(BODY_ACTIVE_CLASS);
    },
    hasSelection: hasSelection,
    canSkip: canSkip
  };

  document.addEventListener('click', onContinueClick, true);

  document.addEventListener('ciw-la-addons:selection-changed', function () {
    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-addons:continue-sync'));
    }, 0);
  });

  var EVENTS = [
    'LensAdvizor:addOns:rendered',
    'LensAdvizor:review:rendered',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:prescriptionTypes:rendered'
  ];

  EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, scheduleScan);
  });

  document.addEventListener('DOMContentLoaded', scheduleScan);

  document.addEventListener('LensAdvizor:selectLensModal:close', deactivateStep);

  var modal = document.getElementById('lensadvizor-prescription-modal');
  if (modal) {
    new MutationObserver(scheduleScan).observe(modal, {
      childList: true,
      subtree: true
    });
  }
})();
